import {HTTP_NOT_FOUND} from "./http.error";
import ClientError from "./client.error";

export default class NotFoundError extends ClientError {
    /**
     * Constructor
     * @param message {string}
     * @param [response] {*}
     * @param [previous] {Error}
     */
    constructor(message, response, previous) {
        super(HTTP_NOT_FOUND, message, response, previous);
        this.name = 'NotFoundError';
    }
}